import { ErrorBoundary } from "react-error-boundary"
import { BottomSheetErrorBoundaryFallback } from "./BottomSheetErrorBoundaryFallback"

type Props = {
  children: React.ReactNode
}

export function BottomSheetErrorBoundary({ children }: Props) {
  return (
    <ErrorBoundary
      fallbackRender={props => <BottomSheetErrorBoundaryFallback {...props} />}
    >
      {children}
    </ErrorBoundary>
  )
}
